import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from "@angular/router";
import { Injectable, Injector, Type } from "@angular/core";
import { SesionService } from "./services/sesion.service";

@Injectable()
export class ExpeditionChangesRouteReuseStrategy implements RouteReuseStrategy {
  private handledExpeditionChange = false;
  constructor(private injector: Injector) {

  }
  private hasChangeType(route: ActivatedRouteSnapshot) {
    const has = !!route.routeConfig.data?.tipoCambio;
    return has;
  }

  private routeCache = new Map<string, DetachedRouteHandle>();

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!this.handledExpeditionChange) {
      this.handledExpeditionChange = true;
      const sesion = this.injector.get(SesionService);
      sesion.expedition$.subscribe(() => {
        try {
          this.routeCache.forEach(h => (h as any)?.componentRef.destroy());
        } catch (error) {
          console.error(error);
        }
        this.routeCache.clear();
      });
    }

    const ret = future.routeConfig === curr.routeConfig;
    return ret;
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const hasChangeType = this.hasChangeType(route);
    return hasChangeType;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const url = this.getFullRouteUrl(route);
    this.routeCache.set(url, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const url = this.getFullRouteUrl(route);
    const ret = this.routeCache.has(url) && !!route.component;
    return ret;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    if (!route.component) {
      return null;
    }
    const url = this.getFullRouteUrl(route);
    const hasChangeType = this.hasChangeType(route)
    return hasChangeType && this.routeCache.has(url)
      ? this.routeCache.get(url)
      : null;
  }


  private getFullRouteUrl(route: ActivatedRouteSnapshot): string {
    return this.getFullRouteUrlPaths(route).filter(Boolean).join('/');
  }

  private getFullRouteUrlPaths(route: ActivatedRouteSnapshot): string[] {
    const paths = this.getRouteUrlPaths(route);
    return route.parent
      ? [...this.getFullRouteUrlPaths(route.parent), ...paths]
      : paths;
  }

  private getRouteUrlPaths(route: ActivatedRouteSnapshot): string[] {
    return route.url.map(urlSegment => urlSegment.path);
  }
}
